import { Component, Input, output } from '@angular/core';

@Component({
  selector: 'rt-tutorial-dialog-nav',
  templateUrl: './tutorial-dialog-nav.component.html',
  styleUrls: ['./tutorial-dialog-nav.component.less'],
  standalone: true,
})
export class TutorialDialogNavComponent {
  @Input() public active: number = 3;

  @Input()
  public set count(val: number) {
    this.iterableArr = this.createArray(val);
  }

  public select = output<number>();

  public iterableArr: number[] = [];

  public trackBy(_index: number, item: number): number {
    return item;
  }

  private createArray(count: number): number[] {
    return Array.from(Array(count).keys());
  }
}
